import React from 'react';
import styled from 'styled-components';
import { Tabs, Tab } from '@material-ui/core';

export const StyledTabs = styled(props => {
  return <Tabs {...props} classes={{ indicator: 'indicator' }}></Tabs>;
})`
  && {
    background-color: #fafafa;
    border-radius: 8px 8px 0 0;
    .MuiTab-wrapper {
      justify-content: center;
      flex-direction: row;
    }
  }
  && .indicator {
    height: 4px;
    background-color: #0880bc;
  }
  && .instruction {
    min-height: 48px;
    padding-right: 10px;
    margin-left: auto;
    background: #fbfbfb 0% 0% no-repeat padding-box;
    border-radius: 4px;
    font-size: 13px;
    justify-content: flex-start;
    font-weight: 500;
    color: #0075c9;
    text-transform: uppercase;
    opacity: 1;
    letter-spacing: 0.02px;
    display: flex;
    align-items: center;
  }
  && .button-container {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    align-items: center;
  }
`;
export const StyledTab = styled(Tab)`
  && {
    color: #212121;
    background: linear-gradient(0deg, #ffffff, #ffffff), #fafafa;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.12);
    font-size: 15px !important;
    line-height: 18px;
    text-transform: none;
    border-right: 1px solid #fff;
    border-left: 1px solid #fff;
    &:focus {
      color: #0880bc !important;
      background-color: #fff !important;
    }
    &&.Mui-selected {
      color: #0880bc;
      background-color: #fff;
    }
  }
`;
export const Container = styled.main`
  background-color: #fff;
  padding: 16px;
`;

export const FeeNoteButton = styled.div`
  min-height: 48px;
  padding-left: 15px;
  background: #fbfbfb 0% 0% no-repeat padding-box;
  border-radius: 4px;
  padding: 2px;
  text-align: end;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .title-class {
    margin-left: 15px;
  }
  .drop-down-button {
    font-size: 13px;
    justify-content: flex-start;
    font-weight: 500;
    color: #0075c9;
    margin-left: 15px;
    margin-right: 15px;
    text-transform: none;
    opacity: 1;
    letter-spacing: 0.02px;
    text-transform: uppercase;
  }
`;
